export const environment = {
    production: true,
    hostUrl: 'https://vtt.dungeonomi.com',
    websocketUrl: 'wss://vtt.dungeonomi.com',
    assetsUrl: 'uvt-assets.s3.us-east-005.backblazeb2.com',
};
